import { memo } from "react";
import { MultiOption, useAdditionalOptions } from "../AdditionalOptions";
import { KYCServiceType, KYCSettingsServicePropertyName } from "consts/kyc";

const AdditionalOptions = () => {
    const { onChange, value } = useAdditionalOptions({
        kycTypeId: KYCServiceType.AddressVerification,
    });

    return (
        <MultiOption
            id='AddressVerification-additional-options'
            options={[
                {
                    id: KYCSettingsServicePropertyName.IncludeIdVerifiedConsumers,
                    name: 'Include Verified Users'
                },
                { 
                    id: KYCSettingsServicePropertyName.AddressShowOcrForm,
                    name: 'Show OCR form'
                }
            ]}
            value={value}
            onChange={onChange}
        />
    );
};

export default memo(AdditionalOptions);
